export default {
	DragPan: {type: 'DragPan', options: {kinetic: [-0.005, 0.05, 100]}},
	PinchZoom: {type: 'PinchZoom'},
	DoubleClickZoom: {type: 'DoubleClickZoom'},
	MouseWheelZoom: {type: 'MouseWheelZoom'},
	KeyboardPan: {type: 'KeyboardPan'},
	KeyboardZoom: {type: 'KeyboardZoom'},
};
